export const environment = {
  production: true,
  availableLocales: ['pl', 'en', 'de', 'es', 'fr', 'ru'],
};
export const getLocalUrl = () => '';
